import {
  asBoolean,
  asDate,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { Author } from "./author";
import { ChatMedia } from "./chat-media";
import { Host } from "./host";
import { Member } from "./member";

export class PollCandidate {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.systemRemove = asBoolean(json.systemRemove);
    this.archive = asBoolean(json.archive);
    this.allowComment = asBoolean(json.allowComment);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.userId = asString(json.userId);
    this.createdAt = asDate(json.createdAt);
    this.pollCandidateId = asString(json.pollCandidateId);
    this.pollName = asString(json.pollName);
    this.profileType = asString(json.profileType);
    this.profileId = asString(json.profileId);
    this.pollId = asString(json.pollId);
    this.pollQuestionId = asString(json.pollQuestionId);
    this.profileIdentifier = asString(json.profileIdentifier);
    this.pollQuestion = asString(json.pollQuestion);
    this.activated = asBoolean(json.activated);
    this.memberId = asString(json.memberId);
    this.manifesto = asString(json.manifesto);
    this.coverImageUrl = asString(json.coverImageUrl);
    this.displayName = asString(json.displayName);
    this.guest = asBoolean(json.guest) ?? false;
    this.author = Author.fromJson(json.author);
    this.host = Host.fromJson(json.host);
    this.member = Member.fromJson(json.member);
    this.media = parseList(json.media, ChatMedia.fromJson);
  }

  get displayNameUse() {
    return this.displayName || this.member?.fullName || this.member?.name;
  }

  get imageUrlToUse() {
    return this.coverImageUrl || this.member?.imageUrl;
  }

  static fromJson(json: any) {
    return isObject(json) ? new PollCandidate(json) : json;
  }
}
